/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* =========================================================
   MOLLY MOORKAMP — TALL ORDER NOTE SYNC

   Keeps existing line-item property:
   Length: Standard / Length: Tall

   Only Tall items are also added to Order Notes as:
   Tall Size: VARIANT-SKU
========================================================= */

(() => {
  if (window.__mmTallOrderNoteSyncLoaded) return;
  window.__mmTallOrderNoteSyncLoaded = true;

  const normalize = (value) => String(value ?? '').trim();

  const getCart = async () => {
    const response = await fetch(`${Shopify.routes.root}cart.js`, {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to read cart.');
    }

    return response.json();
  };

  const saveNote = async (note) => {
    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ note })
    });

    if (!response.ok) {
      throw new Error('Unable to update order note.');
    }

    return response.json();
  };

  const removeGeneratedTallLines = (note) => {
    return String(note || '')
      .split(/\r?\n/)
      .filter((line) => !/^\s*tall size\s*:/i.test(line))
      .join('\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  };

  const buildTallNote = (cart, existingNote) => {
    const customerNote = removeGeneratedTallLines(existingNote);

    const tallLines = cart.items
      .filter((item) => {
        return (
          item.properties &&
          normalize(item.properties.Length).toLowerCase() === 'tall' &&
          normalize(item.sku) !== ''
        );
      })
      .map((item) => `Tall Size: ${normalize(item.sku)}`);

    if (!tallLines.length) {
      return customerNote;
    }

    return [
      customerNote,
      tallLines.join('\n')
    ]
      .filter(Boolean)
      .join('\n\n');
  };

  let syncing = false;
  let syncAgain = false;

  const syncTallOrderNote = async (providedCart = null) => {
    if (syncing) {
      syncAgain = true;
      return;
    }

    syncing = true;

    try {
      const cart = providedCart || await getCart();

      const newNote = buildTallNote(cart, cart.note || '');

      if (newNote.trim() !== String(cart.note || '').trim()) {
        await saveNote(newNote);
      }

      // Keep any visible order-note field synchronized.
      document
        .querySelectorAll('textarea[name="note"]')
        .forEach((textarea) => {
          if (textarea.value !== newNote) {
            textarea.value = newNote;
          }
        });
    } catch (error) {
      console.error('[MM Tall Order Note]', error);
    } finally {
      syncing = false;

      if (syncAgain) {
        syncAgain = false;
        setTimeout(() => syncTallOrderNote(), 0);
      }
    }
  };

  window.mmSyncTallOrderNote = syncTallOrderNote;

  // Prestige fires this after cart additions, removals and updates.
  document.addEventListener('cart:change', (event) => {
    setTimeout(() => {
      syncTallOrderNote(event.detail?.cart || null);
    }, 0);
  });

  document.addEventListener('cart:refresh', () => {
    setTimeout(() => syncTallOrderNote(), 0);
  });

  // Re-sync after the customer edits their own order note.
  document.addEventListener('change', (event) => {
    if (!event.target.matches('textarea[name="note"]')) return;

    setTimeout(() => syncTallOrderNote(), 300);
  });

  // Clean/rebuild Tall lines for carts that already contain Tall items.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => syncTallOrderNote(),
      { once: true }
    );
  } else {
    syncTallOrderNote();
  }
})();